import api from 'api';
import { SelectListingItemProps, SelectListingItem } from 'my-account/components/SelectListingItem';

export interface SelectAgencyGoalProps<IsMulti extends boolean = false>
  extends Omit<
    SelectListingItemProps<typeof api.agencyGoal.listAgencyGoals, IsMulti>,
    'queryFn' | 'getOptionLabel' | 'getOptionValue' | 'queryParams'
  > {
  getOptionLabel?: SelectListingItemProps<typeof api.agencyGoal.listAgencyGoals, IsMulti>['getOptionLabel'];
  queryParams?: SelectListingItemProps<typeof api.agencyGoal.listAgencyGoals, IsMulti>['queryParams'];
}

export const SelectAgencyGoal = <IsMulti extends boolean = false>({
  queryParams = {},
  ...props
}: SelectAgencyGoalProps<IsMulti>) => {
  return (
    <SelectListingItem
      getOptionLabel={(goal) => goal.name}
      {...props}
      queryFn={api.agencyGoal.listAgencyGoals}
      queryParams={{ sort: 'name', direction: 'asc', ...queryParams }}
      getOptionValue={(goal) => String(goal.id)}
    />
  );
};
